import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useDeleteProgram() {
  const { request } = usePbm2Url();
  return useMutation(async (variables: { programCode: string }) => {
    const { Rules_deleteProgram } = await request(
      gql`
        mutation Rules_deleteProgram($programCode: ID!) {
          Rules_deleteProgram(code: $programCode)
        }
      `,
      variables
    );
    return Rules_deleteProgram as boolean;
  });
}
